var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_c('div', {
    staticClass: "card card-custom gutter-b"
  }, [_vm._m(0), _c('div', {
    staticClass: "card-body pt-0 pb-6"
  }, [_vm.loading ? _c('div', {
    staticClass: "text-center py-10"
  }, [_c('b-spinner', {
    attrs: {
      "variant": "primary"
    }
  }), _c('p', {
    staticClass: "mt-3 text-muted"
  }, [_vm._v("Carregando novidades...")])], 1) : _vm.erro ? _c('div', {
    staticClass: "alert alert-light-danger d-flex align-items-center justify-content-between p-4"
  }, [_c('span', [_vm._v(_vm._s(_vm.erro))]), _c('button', {
    staticClass: "btn btn-sm btn-light-danger font-weight-bold",
    on: {
      "click": _vm.carregar
    }
  }, [_vm._v(" Tentar novamente ")])]) : _vm.pacotes.length === 0 ? _c('div', {
    staticClass: "text-center text-muted py-10"
  }, [_vm._v(" Nenhuma novidade publicada ainda. ")]) : _c('div', _vm._l(_vm.pacotes, function (pacote) {
    return _c('div', {
      key: pacote.id,
      staticClass: "card border mb-6 shadow-sm"
    }, [_c('div', {
      staticClass: "card-body"
    }, [_c('div', {
      staticClass: "d-flex align-items-start justify-content-between flex-wrap mb-3"
    }, [_c('div', [_c('h5', {
      staticClass: "font-weight-bolder text-dark mb-1"
    }, [_vm._v(_vm._s(pacote.titulo))]), _c('div', {
      staticClass: "d-flex flex-wrap mb-2",
      staticStyle: {
        "gap": "8px"
      }
    }, [pacote.versao ? _c('span', {
      staticClass: "label label-inline label-light-primary font-weight-bold"
    }, [_vm._v(" Versão " + _vm._s(pacote.versao) + " ")]) : _vm._e(), pacote.data_publicacao ? _c('span', {
      staticClass: "label label-inline label-light-secondary font-weight-bold"
    }, [_vm._v(" " + _vm._s(_vm.formatDate(pacote.data_publicacao)) + " ")]) : _vm._e(), pacote.itens && pacote.itens.length ? _c('span', {
      staticClass: "label label-inline label-light-success font-weight-bold"
    }, [_vm._v(" " + _vm._s(pacote.itens.length) + " " + _vm._s(pacote.itens.length === 1 ? "novidade" : "novidades") + " ")]) : _vm._e()]), pacote.descricao_curta ? _c('p', {
      staticClass: "text-muted font-size-sm mb-0"
    }, [_vm._v(" " + _vm._s(pacote.descricao_curta) + " ")]) : _vm._e()]), _c('button', {
      staticClass: "btn btn-light-primary btn-sm font-weight-bolder mt-2",
      on: {
        "click": function click($event) {
          return _vm.verDetalhes(pacote);
        }
      }
    }, [_vm._v(" Ver detalhes ")])])])]);
  }), 0)])]), _c('ModalNovidades', {
    attrs: {
      "modal-id": "modal-novidades-historico",
      "pacote": _vm.pacoteSelecionado
    },
    on: {
      "fechar": function fechar($event) {
        _vm.pacoteSelecionado = null;
      },
      "lido": function lido($event) {
        _vm.pacoteSelecionado = null;
      }
    }
  })], 1);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "card-header border-0 py-5"
  }, [_c('h3', {
    staticClass: "card-title align-items-start flex-column"
  }, [_c('span', {
    staticClass: "card-label font-weight-bolder text-dark"
  }, [_vm._v(" 🚀 Novidades do Sistema Nuts ")]), _c('span', {
    staticClass: "text-muted mt-3 font-weight-bold font-size-sm"
  }, [_vm._v(" Confira tudo o que foi lançado e melhorado ")])])]);
}];
export { render, staticRenderFns };